import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FaTimes } from 'react-icons/fa';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import styled from 'styled-components';

import ErrorModal from './containers/common/ErrorModal';
import Modal from './containers/common/Modal';
import LoginPage from './containers/LoginPage';
import DashboardHome from './containers/DashboardHome';
import OpsDashboard from './containers/OpsDashboard';
import VideoCallContainer from './containers/VideoCallContainer';
import StyledTappable from './components/common/StyledTappable';
import { BoldText, RegularText } from './components/common/Text';
import modalIcon from './images/common/paymentFail.svg';
import modalSuccessIcon from './images/common/purpleTick.svg';
import { fetchConsults } from './actions';

import { closeJoinMessage, hideError, hideSuccess, initiateVideoCall, closeVerifyLocationAccessModal, checkUserLocationAccess, updateLocationAccessDeniedRemarks, hideAutoDialNotification } from './actions/index';
import './App.css';
import 'react-table/react-table.css';

import 'react-datepicker/dist/react-datepicker.css';
import MasterAdmin from './containers/MasterAdmin';
import ViewSheets from './containers/ViewSheets';
import IciciOpsCenter from './components/IciciOpsCenter';
import IciciDoctorPortal from './components/IciciDoctorPortal';
import BajajOpsCenter from './components/BajajOpsCenter';
import BajajDoctorPortal from './components/BajajDoctorPortal';
import AegonOpsCenter from './components/AegonOpsCenter';
import AegonDoctorPortal from './components/AegonDoctorPortal';
import AutoDialOpsCenter from './components/AutoDialOpsCenter';
import DoctorAttendanceDashboard from './components/DoctorAttendanceDashboard';

const OuterContainer = styled.div`
  display: flex;
  flex: 1 0;
  overflow-y: hidden;
`;

const ModalContainer = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.5);
`;

const ModalBody = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: white;
  max-width: 400px;
  padding: 1.8rem 2rem 3rem 2rem;
  border-radius: 0.8rem;
  margin: 0 1.6rem;
  text-align: center;
`;

const CloseContainer = styled(StyledTappable)`
  align-self: flex-end;
`;

const ModalIcon = styled.img`
  width: 9.1rem;
`;

const ModalText = styled(RegularText)`
  font-size: 1.6rem;
`;

const ModalTitle = styled(BoldText)`
  font-size: 1.1rem;
  margin: 0.625rem 0rem;
`;

const CloseIcon = styled(FaTimes)`
  font-size: 1.4rem;
`;
const ActionButtons = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-evenly;
  padding-top: 12px;
`
const ActionButton = styled.button`
  background: #8852cc;
  color: white;
  border-radius: 5px;
  font-size: 1.5rem;
  margin-top: 12px;
`

const AutoDialToast = styled.div`
  position: fixed;
  top: 2rem;
  right: 2rem;
  z-index: 9999;
  background: #1a1a2e;
  color: #fff;
  border-radius: 0.8rem;
  padding: 1.6rem 2rem;
  min-width: 28rem;
  max-width: 36rem;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.35);
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
  border-left: 4px solid #8852cc;
`

const AutoDialToastHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const AutoDialToastTitle = styled.span`
  font-size: 1.4rem;
  font-weight: 700;
  letter-spacing: 0.05em;
  color: #c9a7ff;
`

const AutoDialToastClose = styled.button`
  background: none;
  border: none;
  color: #aaa;
  font-size: 1.6rem;
  cursor: pointer;
  line-height: 1;
  padding: 0;
  &:hover {
    color: #fff;
  }
`

const AutoDialToastRow = styled.div`
  font-size: 1.3rem;
  color: #e0e0e0;
  display: flex;
  gap: 0.5rem;
`

const AutoDialToastLabel = styled.span`
  color: #aaa;
  min-width: 10rem;
`
class App extends Component {

  constructor(props) {
    super(props);

    // Define initial state
    this.state = {
      locationAccessDeniedRemarks: ''
    };
  }

  hideModal = () => {
    const { dispatch } = this.props;
    dispatch(hideError());
  };
  hideSuccessModal = () => {
    const { dispatch } = this.props;
    dispatch(hideSuccess());
  };
  hideJoinMessageModal = () => {
    const { dispatch } = this.props;
    dispatch(closeJoinMessage());
  };

  hideVerifyLocationAccessModal = () => {
    const { dispatch } = this.props;
    dispatch(closeVerifyLocationAccessModal());
  };

  hideAutoDialNotification = () => {
    const { dispatch } = this.props;
    dispatch(hideAutoDialNotification());
  };

  fetchConsults = () => {
    const { dispatch, authToken, joinMessage } = this.props;
    dispatch(fetchConsults({ authToken, searchText: joinMessage.applicationNo, isInsta: 1 }));
  };

  checkUserLocationAccess = ({ locationAccess, userId }) => {
    const { dispatch } = this.props;
    dispatch(checkUserLocationAccess({ locationAccess, userId }));
  }

  updateLocationAccessDeniedRemarks = ({ userId, locationAccessDeniedRemarks }) => {
    const { dispatch } = this.props;
    dispatch(updateLocationAccessDeniedRemarks({ userId, locationAccessDeniedRemarks }));
  }

  initiateVideoCall = () => {
    const { dispatch } = this.props;
    const isInsta = 1;
    this.fetchConsults();
    setTimeout(() => {
      const { consults } = this.props;
      // Set the consult if available
      if (consults && consults.length > 0) {
        dispatch({ type: 'SET_ACTIVE_CONSULT', payload: { consult: consults[0] } });
      }
      dispatch(initiateVideoCall(isInsta));
    }, 1000);
  };
  render() {
    return (
      <OuterContainer>
        <Router>
          <>
            <Route path="/" exact component={LoginPage} />
            <Route path="/home" component={DashboardHome} />
            <Route path="/admin" component={MasterAdmin} />
            <Route path="/opsDashboard" component={OpsDashboard} />
            <Route path="/video-call" component={VideoCallContainer} />
            <Route path="/view-sheets" component={ViewSheets} />
            <Route path="/icici-ops" component={IciciOpsCenter} />
            <Route path="/icici-doctor" component={IciciDoctorPortal} />
            <Route path="/bajaj-ops" component={BajajOpsCenter} />
            <Route path="/bajaj-doctor" component={BajajDoctorPortal} />
            <Route path="/aegon-ops" component={AegonOpsCenter} />
            <Route path="/aegon-doctor" component={AegonDoctorPortal} />
            <Route path="/bli-welcome-ops" component={AegonOpsCenter} />
            <Route path="/bli-welcome-doctor" component={AegonDoctorPortal} />
            <Route path="/auto-dial-ops" component={AutoDialOpsCenter} />
            <Route path="/attendance" component={DoctorAttendanceDashboard} />
          </>
        </Router>
        {this.props.appError.hasError && (
          <ErrorModal>
            <ModalContainer>
              <ModalBody>
                <CloseContainer onTap={this.hideModal}>
                  <CloseIcon />
                </CloseContainer>
                <ModalIcon src={modalIcon} />
                <ModalTitle>{this.props.appError.errorTitle}</ModalTitle>
                <ModalText>{this.props.appError.errorDesc}</ModalText>
              </ModalBody>
            </ModalContainer>
          </ErrorModal>
        )}
        {this.props.appSuccess.hasSuccess && (
          <Modal>
            <ModalContainer>
              <ModalBody>
                <CloseContainer onTap={this.hideSuccessModal}>
                  <FaTimes />
                </CloseContainer>
                <ModalIcon src={modalSuccessIcon} />
                <ModalTitle>{this.props.appSuccess.messageTitle}</ModalTitle>
                <ModalText>{this.props.appSuccess.messageBody}</ModalText>
              </ModalBody>
            </ModalContainer>
          </Modal>
        )}
        {this.props.joinMessage.visible && (
          <Modal>
            <ModalContainer>
              <ModalBody>
                <CloseContainer onTap={this.hideJoinMessageModal}>
                  <FaTimes />
                </CloseContainer>
                <ModalIcon src={modalSuccessIcon} />
                <ModalTitle style={{ fontSize: '2rem' }}>User Joined the Call</ModalTitle>
                <ModalText>
                  Application No - {this.props.joinMessage.applicationNo}
                  <br />
                  User Name - {this.props.joinMessage.userName}
                </ModalText>
                <ActionButtons>
                  <ActionButton className='btn btn-primary' onClick={this.initiateVideoCall}>Join</ActionButton>
                  <ActionButton className='btn btn-primary' onClick={this.hideJoinMessageModal}>Close</ActionButton>
                </ActionButtons>
              </ModalBody>
            </ModalContainer>
          </Modal>
        )}
        {this.props.verifyLocationAccess.visible && this.props.doctorJoinedVideoSession &&
          (
            <Modal>
              <ModalContainer style={{
                padding: '2rem',
                borderRadius: '16px',
                backgroundColor: '#fff',
                boxShadow: '0 8px 30px rgba(0, 0, 0, 0.1)',
                maxWidth: '500px',
                width: '90%',
                margin: 'auto'
              }}>
                <ModalBody style={{ position: 'relative' }}>
                  {/* <CloseContainer
                    onClick={this.hideVerifyLocationAccessModal}
                    style={{
                      position: 'absolute',
                      top: '1rem',
                      right: '1rem',
                      cursor: 'pointer',
                      fontSize: '1.25rem',
                      color: '#666'
                    }}
                  >
                    <FaTimes />
                  </CloseContainer> */}

                  <ModalTitle style={{
                    fontSize: '2rem',
                    fontWeight: '600',
                    marginBottom: '0.75rem',
                    textAlign: 'center'
                  }}>
                    User Location Consent
                  </ModalTitle>

                  <ModalText style={{
                    color: '#666',
                    fontSize: '1.3rem',
                    textAlign: 'center',
                    marginBottom: '1rem'
                  }}>
                    Please ask the user to enable their <strong>Location</strong> access.
                  </ModalText>

                  <ModalText style={{
                    fontSize: '1.51rem',
                    fontWeight: '500',
                    textAlign: 'center',
                    marginBottom: '1.5rem'
                  }}>
                    Has the user enabled their location access?
                  </ModalText>

                  {this.props.enableLocationAccessError && (
                    <ModalText style={{
                      marginBottom: '1rem',
                      color: '#cc0000',
                      fontWeight: '500',
                      textAlign: 'center'
                    }}>
                      ⚠️ Location permission is not granted.
                    </ModalText>
                  )}

                  <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    gap: '1.25rem',
                    marginBottom: '2rem'
                  }}>
                    <button
                      onClick={() => this.checkUserLocationAccess({ locationAccess: 'yes', userId: this.props.verifyLocationAccess.userId })}
                      style={{
                        padding: '0.75rem 2rem',
                        border: '2px solid #111',
                        backgroundColor: '#fff',
                        color: '#111',
                        borderRadius: '10px',
                        cursor: 'pointer',
                        fontWeight: '600',
                        fontSize: '1.2rem',
                        transition: 'all 0.3s ease',
                      }}
                    >
                      Yes
                    </button>

                    <button
                      onClick={() => this.checkUserLocationAccess({ locationAccess: 'no', userId: this.props.verifyLocationAccess.userId })}
                      style={{
                        padding: '0.75rem 2rem',
                        border: '2px solid #111',
                        backgroundColor: '#111',
                        color: '#fff',
                        borderRadius: '10px',
                        cursor: 'pointer',
                        fontWeight: '600',
                        fontSize: '1.2rem',
                        transition: 'all 0.3s ease',
                      }}
                    >
                      No
                    </button>
                  </div>

                  {this.props.enableLocationRemarksSection && (
                    <>
                      <div style={{ marginBottom: '1.5rem' }}>
                        <label style={{
                          color: '#777',
                          display: 'block',
                          marginBottom: '0.5rem',
                          fontWeight: '500'
                        }}>
                          Enter remarks:
                        </label>
                        <input
                          type="text"
                          placeholder="Enter remarks here"
                          value={this.state.locationAccessDeniedRemarks}
                          onChange={(e) => this.setState({ locationAccessDeniedRemarks: e.target.value })}
                          style={{
                            width: '100%',
                            padding: '0.75rem',
                            border: '1px solid #ccc',
                            borderRadius: '8px',
                            fontSize: '1rem',
                          }}
                        />
                      </div>

                      <button
                        onClick={() => this.updateLocationAccessDeniedRemarks({ userId: this.props.verifyLocationAccess.userId, locationAccessDeniedRemarks: this.state.locationAccessDeniedRemarks })}
                        style={{
                          padding: '0.75rem 2rem',
                          backgroundColor: '#111',
                          color: '#fff',
                          border: 'none',
                          borderRadius: '10px',
                          cursor: 'pointer',
                          fontWeight: '600',
                          fontSize: '1.5rem',
                          width: '100%',
                        }}
                      >
                        Submit
                      </button>
                    </>
                  )}
                </ModalBody>
              </ModalContainer>
            </Modal>
          )
        }
        {this.props.autoDialNotification.visible && (
          <AutoDialToast>
            <AutoDialToastHeader>
              <AutoDialToastTitle>Incoming Auto-Dial Call</AutoDialToastTitle>
              <AutoDialToastClose onClick={this.hideAutoDialNotification}>
                &times;
              </AutoDialToastClose>
            </AutoDialToastHeader>
            <AutoDialToastRow>
              <AutoDialToastLabel>Customer Name:</AutoDialToastLabel>
              <span>{this.props.autoDialNotification.patientName || '—'}</span>
            </AutoDialToastRow>
            <AutoDialToastRow>
              <AutoDialToastLabel>Application No:</AutoDialToastLabel>
              <span>{this.props.autoDialNotification.applicationNo || '—'}</span>
            </AutoDialToastRow>
          </AutoDialToast>
        )}
      </OuterContainer>
    );
  }
}

const mapStateToProps = (state) => ({
  appError: state.app.appError,
  appSuccess: state.app.appSuccess,
  joinMessage: state.app.joinPopup,
  verifyLocationAccess: state.app.verifyLocationAccess,
  enableLocationAccessError: state.app.enableLocationAccessError,
  enableLocationRemarksSection: state.app.enableLocationRemarksSection,
  authToken: state.user.authToken,
  doctorJoinedVideoSession: state.app.doctorJoinedVideoSession,
  consults: state.consults.consults,
  autoDialNotification: state.app.autoDialNotification,
});

export default connect(mapStateToProps)(App);
